export const iconObj = {
  0: '☉︎', 1: '§︎', 2: '#', 3:'^', 4: 'µ︎', 5: '★︎', 6: '☆︎', 7 :'♠︎', 8: '♙︎', 9: '♇︎', 10: '♆︎', 11: '♄︎',
} as const